import { JiraServiceManagementPricingPageProps } from 'src/pages/software/jira/service-management/pricing/jira-service-management-pricing-page';

import { AtlassianGuardAddOnShared } from '@/components/wpl/pricing/src/atlassian-guard-add-on-shared';
import { DataCenterSection } from '@/components/wpl/pricing/src/data-center/data-center-section';
import { PricingFeatureTable } from '@/components/wpl/pricing/src/features-table/features-table';
import {
	useDatacenterPlans,
	usePricingContentContext,
} from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { PricingFaq } from '@/components/wpl/pricing/src/pricing-faq/pricing-faq';
import { QuotationsAdornment } from '@/components/wpl/pricing/src/pricing-faq/quotations';
import { PageHeading } from '@/components/wpl/pricing/src/pricing-page-layout/page-heading';
import { PricingPageLayout } from '@/components/wpl/pricing/src/pricing-page-layout/pricing-page-layout';
import { QuestionsCta } from '@/components/wpl/pricing/src/questions-cta';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { CallToAction } from '@/utils/pricing-queries/get-pricing-content-gql.ts';
import { ParentScrollTracking } from '@/utils/scroll-tracking/parent-scroll-tracker';

import JiraServiceManagementSoftwareNavV2 from '../../../jira-service-management-software-page/src/sections/software-jira-service-management-navbarv2';

import { JsmPriceFinder } from './sections/jsm-price-finder';
// eslint-disable-next-line complexity
export const JiraServiceManagementPricingPageV2Template = (
	props: JiraServiceManagementPricingPageProps,
	// eslint-disable-next-line complexity
) => {
	const content = usePricingContentContext();
	const questionsCtaContent = content?.callToActionContainer?.[0] as CallToAction;
	const dataCenterContent = useDatacenterPlans('Contact Us', 'Learn more');
	return (
		<PricingPageLayout
			nav={<JiraServiceManagementSoftwareNavV2 />}
			showFallback={content?.hasError}
		>
			<ParentScrollTracking scrollTrackingEnabled={true} pageId="jsm-pricing-page">
				<PageHeading>{content?.headline}</PageHeading>
				<JsmPriceFinder pricing={props.pricing} countryCode={props.countryCode} />
				<PricingFeatureTable
					title={content?.compareFeaturesTitle ?? undefined}
					comparePlans={content?.comparePlans ?? undefined}
					compareFeatures={content?.compareFeatures ?? undefined}
				/>
				<AtlassianGuardAddOnShared ctaHref={useLocalizedHref('/software/guard')} />
				<DataCenterSection {...dataCenterContent} />
				<QuotationsAdornment>
					<ParentScrollTracking>
						<PricingFaq
							header={content?.getMoreDetailsTitle ?? undefined}
							planDetails={content?.additionalDetails ?? undefined}
						/>
					</ParentScrollTracking>
				</QuotationsAdornment>
				<QuestionsCta
					product={'JSM'}
					ctaHref={questionsCtaContent?.url ?? undefined}
					questionsHeader={questionsCtaContent?.title ?? undefined}
					priceAndLicensingLinkText={questionsCtaContent?.text ?? undefined}
					questionsBody={questionsCtaContent?.valueProposition ?? undefined}
					imageHref={questionsCtaContent?.asset?.url}
				/>
			</ParentScrollTracking>
		</PricingPageLayout>
	);
};
